import { createSlice } from '@reduxjs/toolkit';

import type { TPaymentMethod } from 'state/tariff-information/tariff-information-slice';

export type PaymentMethodState = {
  data: {
    paymentMethod: TPaymentMethod | null;
  };
};

export const initialState: PaymentMethodState = {
  data: {
    paymentMethod: null
  }
};

export const slice = createSlice({
  name: 'paymentMethod',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setPaymentMethod: (state, { payload }) => {
      state.data.paymentMethod = payload;
    }
  }
});

export const { setPaymentMethod, setInitialState } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectSliceData = (state) => selectSlice(state).data;
export const selectPaymentMethod = (state) =>
  selectSliceData(state).paymentMethod;

export default slice.reducer;
